import { ThemedText, ThemedView } from '@app/theme';

const SectionHeading = ({ heading } : {heading: string}) => {
  return (
    <ThemedView mt='2xl' ml='lg' mb='sm'>
      <ThemedText color='text-primary' variant='h5b'>{heading}</ThemedText>
    </ThemedView>
  );
};

export default SectionHeading;
